class r {
  constructor() {
    this.decimalSeparator = ",";
  }
  zipcode(a) {
    return !!a.match(/^[0-9]{4}\s[a-zA-Z]{2}$/);
  }
}
export {
  r as default
};
